export default "__VITE_ASSET__DfE45hx3__"